import React from 'react';

// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconStop: React.FC<IconType> = ({
  size,
  inverse,
  onClick,
  width,
  height,
  iconClassName,
}) => {

  const defaultMeasurements: Measurements = {
    height: 15,
    width: 15,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-stop">
      <svg
        className="fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1C0 0.447715 0.447715 0 1 0H14C14.5523 0 15 0.447715 15 1V14C15 14.5523 14.5523 15 14 15H1C0.447715 15 0 14.5523 0 14V1Z" />
      </svg>
    </Icon>
  );
};

export default IconStop;
